<div
  class="select-wrapper"
  [class.has-error]="showError"
  [class.disabled]="disabled() || isDisabled"
  [class.readonly]="readOnly()"
>
  <div class="label-container">
    @if (label()) {
      <div class="label-wrapper">
        <label [for]="id()">
          {{ label() }}
          @if (isRequired) {
            <span class="required">*</span>
          }
        </label>
        @if (tooltip()) {
          <lib-tooltip [tooltip]="tooltip()">
            <i-feather
              name="info"
              class="info-icon"
            ></i-feather>
          </lib-tooltip>
        }
      </div>
    }
    @if (showError) {
      <small class="error-message">{{ getErrorMessage() }}</small>
    }
  </div>

  <ng-select
    [items]="filteredOptions"
    bindLabel="label"
    bindValue="value"
    [placeholder]="computedPlaceholder"
    [ngModel]="currentValue"
    (ngModelChange)="handleChange($event)"
    (search)="onSearch($event.term)"
    (open)="onOpen()"
    (close)="onClose()"
    class="custom"
    [id]="id()"
    #select
    dropdownPosition="bottom"
    [closeOnSelect]="!multiple()"
    [virtualScroll]="true"
    [multiple]="multiple()"
    [clearable]="clearable()"
    [disabled]="disabled() || isDisabled || readOnly()"
    appendTo="body"
  >
    <ng-template
      ng-option-tmp
      let-item="item"
      let-search="searchTerm"
    >
      <div class="option-item">
        @if (item.svgUrl) {
          <img
            [src]="item.svgUrl"
            alt="{{ item.label }}"
            class="flag-icon"
            [style]="{
              width: '20px',
              height: '15px',
              borderRadius: '2px',
            }"
          />
        }
        <span>{{ item.label }}</span>
      </div>
    </ng-template>
  </ng-select>
</div>
